import { SecondaryTrackRendererType } from '@cxstudio/conversation/secondary-track-renderer-type.enum';

export const SPINE_LANE_ICONS = [
	{ name: '\uf15f', value: SecondaryTrackRendererType.CIRCLE, css: 'iconButton'},
	{ name: '\uf17f', value: SecondaryTrackRendererType.DIAMOND, css: 'iconButton'}
];
